import {
  RecurringExamEventCreationFormProvider,
  RecurringExamEventCreationProvider,
} from '@exam-center/exam-event-creation';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function recurringExamEventCreateLayout() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.CREATE}>
      <RecurringExamEventCreationProvider>
        <RecurringExamEventCreationFormProvider>
          <Outlet />
        </RecurringExamEventCreationFormProvider>
      </RecurringExamEventCreationProvider>
    </PermissionGuard>
  );
}
